import React from 'react'

const DirectoryActive = props => (
  <svg width={25} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.115 2h13a1.5 1.5 0 0 1 1.5 1.5v5h-16v-5a1.5 1.5 0 0 1 1.5-1.5zm8.853 4.854a.5.5 0 0 0 .147-.354v-1a.5.5 0 1 0-1 0V6h-3v-.5a.5.5 0 1 0-1 0v1a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .353-.146zM4.615 14.5h16v-5h-16v5zm5.5-3a.5.5 0 0 1 1 0v.5h3v-.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1zm-5.5 9a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-5h-16v5zm5.5-3a.5.5 0 0 1 1 0v.5h3v-.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1z"
      fill="#00C2C9"
    />
  </svg>
)

export default DirectoryActive
